import { render, staticRenderFns } from "./ValidatableOrganizerSelection.vue?vue&type=template&id=95ca76f6&"
import script from "./ValidatableOrganizerSelection.vue?vue&type=script&lang=js&"
export * from "./ValidatableOrganizerSelection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports